import { BirthBaby, BirthHeart, BirthPortrait } from './BirthArtwork'

/**
 * Opening scene copied from the external HTML reference. The Canvas above
 * this component supplies impact rings, dust, flashes, and missiles; these
 * DOM stages remain ordinary SVG/HTML so they stay crisp on Retina screens
 * and inside WKWebView.
 */
export function BirthScene() {
  return <div className="reference-birth" aria-hidden="true">
    <div className="birth-bg" />

    <div className="birth-stage heart">
      <BirthHeart />
    </div>

    <div className="birth-stage baby">
      <BirthBaby />
    </div>

    <div className="birth-stage frame">
      <div className="birth-frame">
        <div className="birth-frame-inner">
          <BirthPortrait />
        </div>
      </div>
    </div>

    <div className="birth-stage text">
      <div className="born-text">
        {['恭', '喜', '你', '成', '功', '落', '地', '！'].map((character, index) => <span className="bl" key={`${character}-${index}`}>{character}</span>)}
      </div>
    </div>

    <div className="birth-flash" />
  </div>
}
